import "./GarageDoorRepairEasternSuburbs.module.css";
import Header from "@/reusable_sections/Header";
import GarageHero from "./sections/GarageHero";
import Location from "./sections/Location";
import Locationservicesplaceholder from "./sections/Locationservicesplaceholder";
import Partners from "./sections/Partners";
import GarageProcess from "./sections/GarageProcess";
import GarageWhyUs from "./sections/GarageWhyUs";
import Locationsuburbs from "./sections/Locationsuburbs";
import Testimonials from "./sections/Testimonials";
import GarageFaq from "./sections/GarageFaq";
import GarageService from "./sections/GarageService";
import Footer from "./sections/Footer";
export default function GarageDoorRepairEasternSuburbsPage() {
  return <div>
      <Header />
      <GarageHero />
      <Location />
      <Locationservicesplaceholder />
      <Partners />
      <GarageProcess />
      <GarageWhyUs />
      <Locationsuburbs />
      <Testimonials />
      <GarageFaq />
      <GarageService />
      <Footer />
    </div>;
}